export default "__VITE_ASSET__739230a0__"